import React from 'react'
import { Search, X } from 'lucide-react'
import { tx } from '../../lib/i18n'

interface FilterConfig {
  key: string
  label: string
  options: { label: string; value: string }[]
  value: string
  onChange: (v: string) => void
}

interface FilterBarProps {
  search?: {
    value: string
    onChange: (v: string) => void
    placeholder?: string
  }
  filters?: FilterConfig[]
  onReset?: () => void
}

const FilterBar: React.FC<FilterBarProps> = ({ search, filters = [], onReset }) => {
  const hasActiveFilters =
    (search?.value && search.value.length > 0) || filters.some((f) => f.value !== '')

  return (
    <div className="flex flex-wrap items-center gap-3">
      {search && (
        <div className="relative flex-1 min-w-[200px] max-w-xs">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
          <input
            type="text"
            value={search.value}
            onChange={(e) => search.onChange(e.target.value)}
            placeholder={search.placeholder ?? tx('Search...')}
            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder-gray-400"
          />
          {search.value && (
            <button
              onClick={() => search.onChange('')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      )}
      {filters.map((filter) => (
        <div key={filter.key}>
          <select
            value={filter.value}
            onChange={(e) => filter.onChange(e.target.value)}
            className="text-sm border border-gray-200 rounded-lg bg-white px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">{filter.label}: {tx('All')}</option>
            {filter.options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      ))}
      {hasActiveFilters && onReset && (
        <button
          onClick={onReset}
          className="flex items-center gap-1.5 px-3 py-2 text-sm text-gray-500 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition-colors"
        >
          <X className="h-3.5 w-3.5" />
          {tx('Reset')}
        </button>
      )}
    </div>
  )
}

export default FilterBar
